import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=b4fca34a&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fca34a",
  null
  
)

export default component.exports